import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import PageLoader from "../../../../../components/PageLoader";

const DBACollectionMappings = ({ selectedDba }: any) => {
  const navigate = useNavigate()
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      }, { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text', callback: handleEditCollectionMapping },
      { field: 'EntityTypeName', headerName: 'Entity Type Name', searchField: 'EntityTypeName', sortable: true, filter: true, filterType: 'text' },
      // { field: 'AssociatedAccountName', headerName: 'Associated Account Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'StartDateUtc', headerName: 'Start Date', isDateValueFormat: true, },
      { field: 'EndDateUtc', headerName: 'End Date', isDateValueFormat: true, },
      // { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      // { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Collection Mapping</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
  ];

  const handleAdd = () => {
    navigate(`/management/policy/organization/collections/${0}`)
  }

  const handleEditCollectionMapping = (data: any) => {
    navigate(`/management/policy/organization/collections/${data?.Id}`)
  }

  useEffect(() => {
    createColumnDefs();
  }, [selectedDba])

  return (
    <>
      {selectedDba?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={selectedDba?.CollectionPolicies?.[0]?.Collections}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          additionButtons={additionButtons}
          headingName="DBA Collection Mappings"
        />
      }
    </>
  );
};

export default DBACollectionMappings;


